import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import { csvParse, utcParse, bisector, min, max, mean } from 'd3'
import Selector from './Selector';
import PeriodSelector from './PDPeriodSelector';
import Timeline from './Timeline';
import { PremiumDiscountValues } from './MarketValues';
import { DATE, PREMDIS_$, PREMDIS_PCT } from './constants';
import { periods } from './periods';
import { positiveBarColor, negativeBarColor, highlightColor } from './pallette';
import SummaryTable from './SummaryTable';
//import { translate } from './translate';


const filteredData = createSelector(
  (props, state) => state.data,
  (props, state) => state.selectedPeriod,
  (props, state) => state.data[state.data.length - 1][DATE],
  (props, state) => state.customPeriod,
  (data, selectedPeriod, latestDate, customPeriod) => {
    // const timeRange = selectedPeriod === 'CUSTOM' ? customPeriod : [periods[selectedPeriod](latestDate), latestDate]
    var timeRange = ''
    if (selectedPeriod === 'CUSTOM') {
      timeRange = customPeriod
    } else if (selectedPeriod === 'PCY') {
      timeRange = getQuarter('PCY')

    } else if (selectedPeriod === 'Q1') {
      timeRange = getQuarter('Q1')

    } else if (selectedPeriod === 'Q2') {

      timeRange = getQuarter('Q2')

    } else if (selectedPeriod === 'Q3') {
      timeRange = getQuarter('Q3')

    } else if (selectedPeriod === 'Q4') {

      timeRange = getQuarter('Q4')
    } else {
      timeRange = [periods[selectedPeriod](latestDate), latestDate]
    }
    console.log('TimeRange***', timeRange, 'selectedPeriod', selectedPeriod)
    selectedPeriod === 'CUSTOM' ? customPeriod : [periods[selectedPeriod](latestDate), latestDate]

    const filteredData = data.filter(d => d[DATE] >= timeRange[0] && d[DATE] <= timeRange[1])
    return filteredData
  }
)



const availableTimeRange = createSelector(
  (props, state) => state.data[0][DATE],
  (props, state) => state.data[state.data.length - 1][DATE],
  (firstDate, latestDate) => [firstDate, latestDate]
)

const summarize = createSelector(
  filteredData,
  (props, state) => state.selectedPeriod,
  (props, state) => state.selectedMetric,
  props => props.i18n,
  props => props.lang,
  (data, selectedPeriod, selectedMetric, i18n, lang) => {
    const period = i18n[selectedPeriod][lang]
    const fn = d => d[selectedMetric][0]
    return [
      { label: `${period} ${i18n['HIGH'][lang]}`, value: max(data, fn) },
      { label: `${period} ${i18n['LOW'][lang]}`, value: min(data, fn) },
      { label: `${period} ${i18n['AVERAGE'][lang]}`, value: mean(data, fn) }
    ]
  }
)

function getQuarter(id) {
  var d = new Date();
  var quarter = Math.floor((d.getMonth() / 3));

  var firstDate = '';
  var endDate = '';
  switch (id) {
    case "Current":
      firstDate = new Date(d.getFullYear(), quarter * 3, 1);
      endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);
      break;
    case "PCY":
      firstDate = new Date(d.getFullYear() - 1, 0, 1);
      endDate = new Date(
        firstDate.getFullYear(), 11, 31);
      break;
    case "Q1":
      firstDate = new Date(d.getFullYear(), 0, 1);
      endDate = new Date(firstDate.getFullYear(), 2, 31);
      console.log(firstDate, endDate)
      break;
    case "Q2":
      firstDate = new Date(d.getFullYear(), 3, 1);
      endDate = new Date(firstDate.getFullYear(), 5, 30);
      break;
    case "Q3":
      firstDate = new Date(d.getFullYear(), 6, 1);
      endDate = new Date(firstDate.getFullYear(), 8, 30);
      break;
    case "Q4":
      firstDate = new Date(d.getFullYear(), 9, 1);
      endDate = new Date(firstDate.getFullYear(), 11, 31);
      break;
  }

  return ([firstDate, endDate])
}



const dataAtMouse = createSelector(
  filteredData,
  (props, state) => state.mouseDate,
  (data, mouseDate) => {
    if (!mouseDate) return data[data.length - 1]
    const bisectDate = bisector((d, x) => d[DATE] - x).left
    const index = bisectDate(data, mouseDate)
    return data[index]
  }
)

const parseDate = utcParse('%-m/%-d/%Y')
const parseCsvNum = (value, divideBy = 1) => value === '' ? null : (+value) / divideBy


class PremiumDiscountWidget extends PureComponent {
  constructor() {
    super()
    this.state = {
      selectedMetric: PREMDIS_$,
      selectedPeriod: 'YTD',
      customPeriod: null,
      mouseDate: null,
      data: csvParse(window.fundPremiumDiscountData, (d) => (
        {
          ...d,
          [DATE]: parseDate(d[DATE]),
          [PREMDIS_$]: [parseCsvNum(d[PREMDIS_$])],
          [PREMDIS_PCT]: [parseCsvNum(d[PREMDIS_PCT], 100)],
        }
      )),
      data2: csvParse(window.fundPremiumDiscountData, (d) => (
        {
          ...d,
          [DATE]: new Date(Date.parse((d[DATE]))),
          [PREMDIS_$]: [parseCsvNum(d[PREMDIS_$])],
          [PREMDIS_PCT]: [parseCsvNum(d[PREMDIS_PCT], 100)],
        }
      )),

    }
    this.handleSelectMetric = this.handleSelectMetric.bind(this)
    this.handleSelectPeriod = this.handleSelectPeriod.bind(this)
    this.handleMouseDate = this.handleMouseDate.bind(this)
  }
  handleSelectMetric(selectedMetric) {
    this.setState({ selectedMetric })
  }
  handleSelectPeriod(selectedPeriod, customPeriod) {
    this.setState({ selectedPeriod, customPeriod })
  }
  handleMouseDate(mouseDate) {
    this.setState({ mouseDate })
  }


  render() {
    const { width, i18n, lang } = this.props
    const { selectedMetric, selectedPeriod, mouseDate, customPeriod } = this.state
    const data = filteredData(this.props, this.state)
    const data2 = this.state.data2
    const marginLeft = 30
    const marginRight = width >= 768 ? 100 : 70

    return (
      <div>
        <div className='Selector-row'>
          <Selector
            onSelect={this.handleSelectMetric}
            options={[
              { id: PREMDIS_$, label: '$' },
              { id: PREMDIS_PCT, label: '%' }
            ]}
            selected={selectedMetric}
          />
        </div>
        <div className='Selector-row'>
          <PeriodSelector
            availableTimeRange={availableTimeRange(this.props, this.state)}
            onSelect={this.handleSelectPeriod.bind(this)}
            selected={selectedPeriod}
            customPeriod={customPeriod}
            i18n={i18n}
            lang={lang}
          />
        </div>
        <PremiumDiscountValues
          shouldLabelAsOf={!mouseDate}
          valueFormat={selectedMetric === PREMDIS_PCT ? '.3%' : '.2f'}
          valueProp={selectedMetric}
          datum={dataAtMouse(this.props, this.state)}
          summaries={summarize(this.props, this.state)}
          i18n={i18n}
          lang={lang}
        />
        {width !== null ?
          <Timeline
            data={data}
            yDimension={selectedMetric}
            yFormat={selectedMetric === PREMDIS_PCT ? '.3%' : '.2f'}
            width={width + marginLeft}
            height={240}
            colorScale={v => highlightColor}
            barColors={[positiveBarColor, negativeBarColor]}
            margin={{ t: 10, r: marginRight, b: 30, l: marginLeft }}
            mouseDate={mouseDate}
            onMouseDate={this.handleMouseDate}
            yStartFromZero={true}
            renderAsBars={false}
            alwaysHighlightLatest={false}
          /> : null
        }
        {width !== null && lang === 'en' ?
          <SummaryTable
            data2={data2}
          /> : null
        }
      </div>
    )
  }
}

export default PremiumDiscountWidget


// WEBPACK FOOTER //
// ./src/PremiumDiscountWidget.js